/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_Calm_Bulldog_ZoomInputs */

const fr_civil_calm_bulldog_zoom = /** @type {(inputs: Civil_Calm_Bulldog_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun participant selectionné`)
};

/**

* @param {Civil_Calm_Bulldog_ZoomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_calm_bulldog_zoom = /** @type {((inputs?: Civil_Calm_Bulldog_ZoomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Calm_Bulldog_ZoomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_calm_bulldog_zoom(inputs)
});